import { Divider } from '@material-ui/core';
import BlockOutlinedIcon from '@material-ui/icons/BlockOutlined';
import VerifiedUserOutlinedIcon from '@material-ui/icons/VerifiedUserOutlined';
import { TextLinkButton } from 'framework/components/buttons/TextLinkButton';
import { CardX } from 'framework/components/cards/CardX';
import { StatusIcon } from 'framework/components/icons/StatusIcon';
import { LabelledPropertyX } from 'framework/components/labelledProperty/LabelledPropertyX';
import { Typography16pxBold } from 'framework/components/typography/Typography16pxBold';
import { AlertDialog } from 'framework/dialogs/AlertDialog';
import { disableCochlearIntegration_handle, enableCochlearIntegration_handle, ICochlearSettingsDto } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';

type CochlearSettingsTabProps = {
	settings: ICochlearSettingsDto;
	reload: VoidFunction;
};

export const CochlearSettingsTab = ({ reload, settings }: CochlearSettingsTabProps) => {
	const strings = useLocalization();
	const { open, confirm, cancel } = useDialogsContext(reload);

	const onEnable = () => {
		open(
			<AlertDialog
				open
				title={`Enable COCHLEAR integration`}
				content={`Are you sure?`}
				acceptText={`Yes!`}
				rejectText={`No, go back`}
				reject={cancel}
				acceptF={() => enableCochlearIntegration_handle({})}
				accept={confirm}
			/>
		);
	};

	const onDisable = () => {
		open(
			<AlertDialog
				open
				title={`Disable COCHLEAR integration`}
				content={`Are you sure?`}
				acceptText={`Yes!`}
				rejectText={`No, go back`}
				reject={cancel}
				acceptF={() => disableCochlearIntegration_handle({})}
				accept={confirm}
			/>
		);
	};

	return (
		<div
			className='df-col gap-16'
			style={{ padding: 16, maxWidth: 1280, height: '100%' }}>
			<CardX className='df-col gap-8'>
				<Typography16pxBold>{strings.settings}</Typography16pxBold>
				<LabelledPropertyX
					iconPosition='start'
					icon={<StatusIcon status={settings.enabled ? 'success' : 'error'} />}
					label={strings.status}>
					{settings.enabled ? strings.active : strings.notActive}
				</LabelledPropertyX>
				<div className='df-row-ac gap-8'>
					<TextLinkButton
						startIcon={<VerifiedUserOutlinedIcon />}
						color='primary'
						onClick={onEnable}
						disabled={settings.enabled}>
						{`Enable`}
					</TextLinkButton>
					<Divider orientation='vertical' />
					<TextLinkButton
						startIcon={<BlockOutlinedIcon />}
						hoverColor='secondary'
						onClick={onDisable}
						disabled={settings.enabled === false}>
						{`Disable`}
					</TextLinkButton>
				</div>
				<Divider />
				<LabelledPropertyX
					iconPosition='start'
					icon={<StatusIcon status={settings.isPartner ? 'success' : 'error'} />}
					label={'Partner?'}>
					{settings.isPartner ? strings.active : strings.notActive}
				</LabelledPropertyX>
			</CardX>
		</div>
	);
};
